import { render, staticRenderFns } from "./vCarousel-main.vue?vue&type=template&id=0df8313b&scoped=true"
import script from "./vCarousel-main.vue?vue&type=script&lang=js"
export * from "./vCarousel-main.vue?vue&type=script&lang=js"
import style0 from "./vCarousel-main.vue?vue&type=style&index=0&id=0df8313b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df8313b",
  null
  
)

export default component.exports